



























































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import MoreControlBtn from "./moreControlBtn.vue";
import PatientDetail from "./patientDetail.vue";
@Component({
  components: {
    MoreControlBtn,
    PatientDetail,
  },
})
export default class TongueTextList extends Vue {
  @Prop()
  private tongues;
  @Prop()
  private pageCount;
  @Prop()
  private currentPage;
  private ifShowPatientDetail: boolean = false;
  private temp: any = {};
  /**
   * @description 处理点击更多选项
   */
  private handleMoreControl(command, tongue) {
    switch (command) {
      case "放入回收站":
        this.$emit("deleteOne", tongue);
        break;
      case "报告预览":
        this.$emit("preview", tongue);
        break;
      case "修改基本信息":
        this.ifShowPatientDetail = true;
        this.temp = _.cloneDeep(tongue);
        break;
    }
  }
  /**
   * @description 切换选中的舌图
   */
  private handleCheckedMessageChange(event, message) {
    this.$emit("trigger", message);
  }
  /**
   * @description 跳转智能标注
   */
  private jumpBiaozhu(message) {
    this.$router.push({
      path: "/main/tongue/biaozhu-detail",
      query: {
        tongue_id: message.tongue_id,
      },
    });
  }
  /**
   * @description 跳转智能比对
   */
  private jumpBidui(message) {
    localStorage.removeItem("selectedTongues");
    localStorage.setItem("selectedTongues", JSON.stringify([message]));
    this.$router.push({
      path: "/main/tongue/bidui-list",
    });
  }
  /**
   * @description 需要刷新
   */
  private refresh() {
    this.$emit("refresh");
  }
}
